var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.875 28.4999V15.9572C49.875 10.7562 49.875 8.15563 48.1952 6.7327C46.5156 5.30976 43.9482 5.73767 38.8132 6.5935L36.309 7.01086C32.4133 7.66013 30.4656 7.98475 28.5 7.98475C26.5344 7.98475 24.5867 7.66013 20.691 7.01086L18.1868 6.5935C13.0519 5.73767 10.4844 5.30976 8.80472 6.7327C7.125 8.15563 7.125 10.7562 7.125 15.9572V28.4999C7.125 41.5393 17.1925 47.8673 23.5091 50.5541C25.2225 51.283 26.0792 51.6476 28.5 51.6476C30.9208 51.6476 31.7775 51.283 33.4908 50.5541C39.8074 47.8673 49.875 41.5393 49.875 28.4999Z",
    stroke: "black",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 21.375C16.1289 19.9913 17.9945 19 20.1875 19C22.3805 19 24.2461 19.9913 24.9375 21.375",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 21.375C32.7539 19.9913 34.6194 19 36.8125 19C39.0056 19 40.8711 19.9913 41.5625 21.375",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 33.25C20.1875 33.25 22.6813 35.625 28.5 35.625C34.3188 35.625 36.8125 33.25 36.8125 33.25",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/funny.d83c610de8aa2e506c7f7ab77ce90606.svg";
export { ForwardRef as ReactComponent };